import React from 'react';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.css';
import '@fortawesome/fontawesome-free/css/all.css';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import 'react-quill/dist/quill.snow.css';
import 'react-notifications/lib/notifications.css';

import AppRouter from './router/AppRouter';
import '../styles/css/app.css';
import '../polyfills';
import packageJson from '../../package.json';
import configStore from '../store/configStore';

global.appVersion = packageJson.version;

const store = configStore();

const App = () => {
  return (
    <Provider store={store}>
      <AppRouter />
    </Provider>
  );
};

export default App;
